import CopyFeedbackURLToClipboard from '@modules/feedback/components/FeedbackCard/CopyFeedbackURLToClipboard';
import { SaveFeedback } from '@modules/feedback/components/FeedbackCard/SaveFeedback';
import { FeedbackDetailsHeaderPagination } from '@modules/feedback/components/FeedbackDetails/FeedbackDetailsHeader/FeedbackDetailsHeaderPagination';
import { Stack } from '@mui/material';
import { Feedback } from 'v2/core/entities/feedback';

interface FeedbackDetailsHeaderRightActionsProps {
  feedback: Feedback;
  onDrawerClose?: () => void;
  setCurrentFeedbackIndex?: (index: number) => void;
  setCurrentFeedback?: (feedback: Feedback) => void;
  feedbacks?: Feedback[];
  currentFeedbackIndex?: number;
  totalRecords?: number;
  isLoadingMore?: boolean;
}

export const FeedbackDetailsHeaderRightActions = ({
  feedback,
  onDrawerClose,
  setCurrentFeedback = (feedback: Feedback) => {},
  setCurrentFeedbackIndex = (index: number) => {},
  feedbacks = [],
  currentFeedbackIndex = 0,
  totalRecords = 0,
  isLoadingMore,
}: FeedbackDetailsHeaderRightActionsProps) => {
  return (
    <Stack spacing={2} direction="row" alignItems="center">
      <>
        <FeedbackDetailsHeaderPagination
          shouldShowPagination={Boolean(onDrawerClose)}
          currentFeedbackIndex={currentFeedbackIndex}
          setCurrentFeedback={setCurrentFeedback}
          setCurrentFeedbackIndex={setCurrentFeedbackIndex}
          feedbacks={feedbacks}
          totalRecords={totalRecords}
        />
        {!isLoadingMore && (
          <>
            <SaveFeedback feedbackID={feedback.id} />
            <CopyFeedbackURLToClipboard feedbackID={feedback.id} isDetailView />
          </>
        )}
      </>
    </Stack>
  );
};
